import React, { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/configureStore";
import { GiSpeaker, GiSpeakerOff } from "react-icons/gi";
import { getSessionSetting } from "../selectors";
import { setSessionSetting } from "../sessionSlice";
import useSessionId from "../useSessionId";

const ToggleMuteButton = () => {
  const dispatch = useAppDispatch();
  const sessionId = useSessionId();
  const isMuted = useAppSelector(getSessionSetting(sessionId, "isMuted"));

  const toggleMute = useCallback(() => {
    dispatch(setSessionSetting(sessionId, "isMuted", !isMuted));
  }, [dispatch, isMuted, sessionId]);

  return (
    <button onClick={toggleMute} type="button">
      {isMuted ? <GiSpeakerOff size={35} /> : <GiSpeaker size={35} />}
      <style jsx>{`
        button {
          padding: 0;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          background: transparent;
        }
      `}</style>
    </button>
  );
};

export default ToggleMuteButton;
